export const DEFAULT_GEO_LABEL_DESCRIPTIONS = {
  globalRegion: 'There are 3 CBRE global regions (Americas, APAC, EMEA)',
  country: 'Country',
  region: 'A broad area of the country such as Southern CA, the Southeast, the Midwest, etc...',
  market: `An area which corresponds to a CBRE LMA. It may have one or more CBRE offices
    (ex: Dallas, Atlanta, Los Angeles, Orange country)`,
  submarket: `An area used to segment a market at a high level into different areas of commercial buildings that can be
     grouped based on geography, proximity to attractions, etc... There are typically less than 10 in each market`,
  district: `An area that contains comparable buildings. Generally if a tenant was looking in a district,
    they would see similar rates in most properties and similar access to talent`,
  neighborhood: `A small area, measured in blocks in dense areas and small communities in suburban environments that
    provides access to the same amenities`,
};
